<template>
  <span
      v-if="!isMobileApp"
    class="flex flex-col p-2 ds-text-sm font-medium text-gray-900 bg-gray-200 border border-blue-300 border-solid rounded"
  >
    <span>
      College coach?
      <a href="/login" class="font-bold">Log in</a>
      to see {{user.firstName}}'s full profile.
    </span>
  </span>
</template>

<script>
import { mapState } from "vuex";
import SRCookies from "@/services/cookies";
export default {
  computed: {
    ...mapState({
      user: state => state.athleteProfile.user
    }),
    isMobileApp() {
      return SRCookies.isMobileSession()
    },
  }
};
</script>

<style scoped>
</style>
